module.exports = __webpack_public_path__ + "img/tolid.bb7c0da0.jpg";